import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Section from './Section.js';
import LeadInfo from './LeadInfo.js';

function Inspected(props) {
    const { clientName } = props;

    return (
        <Section className="intro_form">
            <Row>
                <Col className="text-center" xs={12} md={12} lg={12}>
                    <div className="header-img">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                    </div>
                </Col>
                <Col className="text-center inspected-content" xs={10} xsOffset={1} md={8} mdOffset={2} lg={6} lgOffset={3}>
                    <div className="pvc-container">
                        <img alt="Asesor" className="inspected-img" src={require(`../assets/${process.env.PAGE}/img/image-52.svg`)} />
                        <h3><b>¡Excelente, {clientName}! Ya recibimos tus datos.</b></h3>
                        <p>Nuestro equipo de asesores está revisando la mejor opción para vos. Mantené tu teléfono cerca, nos comunicaremos con vos en breve.</p>
                    </div>
                </Col>
            </Row>
        </Section>
    );
}

export default LeadInfo(Inspected);



/** WEBPACK FOOTER **
 ** ./src/components/Inspected.js
 **/